module.exports = __webpack_public_path__ + "media/audio19.5fb52908.mp3";